import { useContext, useEffect, useState } from "react"
import {
    SidePopupContainer, FlexColumn, Button,
    Form, FormGroup, FlexRow, AppSpan,
    ReactSelect
} from "src/style"
import { RiCloseFill } from "react-icons/ri"
import utility from "src/utils/utility"
import { UserType } from "src/model"
import ApiContext from "src/provider/API/call-service"
import { CONSTANTs } from "src/provider/config/constant"

export const Create_Edit_AdminUser: React.FC<any> = ({ getUsers, rowData, close }) => {
    const { API } = useContext(ApiContext)

    const [input, setInput] = useState({ type: UserType.ADMIN, firstName: '', lastName: '', email: '', roleId: CONSTANTs.adminUserCreationRoleId})

    useEffect(() => {
        if (rowData) {
            const { type, firstName, lastName, email, roleId } = rowData
            setInput({...input, type, firstName, lastName, email, roleId})
        }
    }, [rowData])

    const handleInput = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => setInput({ ...input, [e.target.name]: e.target.value })

    async function handleSubmit(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()

        const payload: any = {
            ...input
        }

        const response = await API.createUser(payload)
        if (response) {
            getUsers()
            close()
        }
    }

    return (
        <>
            <SidePopupContainer zIndex="8" onClick={close} />
            <FlexColumn
                className="center-popup-container"
                justifyContent="flex-start"
                alignItems="flex-start"
            >
                <FlexRow justifyContent='space-between' gap='2'>
                    <AppSpan color='#101828' textSize='1.8' fontWeight="600">{rowData ? 'Edit User' : 'Create User'}</AppSpan>
                    <Button
                        titleSize="2" fontWeight="500"
                        width='3.4' shadow='none'
                        height='3.4'
                        radius='0.4'
                        bgColor='#ffffff'
                        hoverBgColor='#FEF3F2'
                        borderColor='none'
                        color='#000000'
                        hoverColor='#B42318'
                        onClick={close}
                    >
                        <RiCloseFill style={{ fontSize: '2.3rem' }} />
                    </Button>
                </FlexRow>
                <Form onSubmit={handleSubmit} topMargin='2'>
                    <FormGroup>
                        <label>First Name</label>
                        <input
                            placeholder="Enter first name"
                            name='firstName'
                            value={input.firstName}
                            onChange={handleInput}
                        //required
                        />
                    </FormGroup>
                    <FormGroup>
                        <label>Last Name</label>
                        <input
                            placeholder="Enter last name"
                            name='lastName'
                            value={input.lastName}
                            onChange={handleInput}
                        //required
                        />
                    </FormGroup>
                    <FormGroup>
                        <label>Email</label>
                        <input
                            placeholder="Enter email"
                            type='email'
                            name='email'
                            value={input.email}
                            onChange={handleInput}
                        //required
                        />
                    </FormGroup>

                    <FlexRow justifyContent='flex-end'>
                        <Button
                            width='12.9'
                            titleSize='1.4' fontWeight="500"
                            height='4' radius='0.8'
                            bottomMargin='1' hoverColor='#0D968F'
                            hoverBgColor='#fff' borderColor='#0D968F'
                        >
                            {rowData ? 'Save changes' : 'Submit'}
                        </Button>
                    </FlexRow>
                </Form>
            </FlexColumn>
        </>
    )
}